import React, { useState, useEffect } from "react";
import { PlayerContainer, PostContainer, Content } from "./Shared";
import Player from "react-player";
import PostFooter from "../PostFooter/PostFooter";
import Picture from "components/Picture";
import styled from "styled-components";

const StyledPicture = styled(Picture)`
  img {
    width: 100%;
    height: auto;
    border-radius: 25px;
  }
`;

export default function TvPost(props) {
  const [playing, setPlaying] = useState(false);
  const renderPostFooter = () =>
    props.activeAudience || props.showPostFooter ? (
      <PostFooter {...props} />
    ) : null;

  useEffect(
    function mount() {
      function onScroll() {
        setPlaying(false);
      }

      window.addEventListener("scroll", onScroll);

      return function unMount() {
        window.removeEventListener("scroll", onScroll);
      };
    },
    [playing, setPlaying]
  );

  return (
    <PostContainer {...props}>
      <Content noPadding>
        {props.image ? (
          <StyledPicture
            image={props.image || props.content}
            imageAlt={props.imageAlt}
            width={500}
          />
        ) : (
          <PlayerContainer>
            <Player
              controls={true}
              url={props.url}
              playing={playing}
              width="100%"
              onPlay={() => {
                setPlaying(true);
              }}
              onPause={() => {
                setPlaying(false);
              }}
              onEnded={() => {
                setPlaying(false);
              }}
            />
          </PlayerContainer>
        )}
      </Content>
      {renderPostFooter()}
    </PostContainer>
  );
}
